export default function combineReducers(reducers) {
  if (reducers === void 0) {
    reducers = {};
  }

  var reducerKeys = Object.keys(reducers);
  return function combination(state, action, fullState) {
    if (state === void 0) {
      state = {};
    }

    var hasChanged = false;
    var nextState = {};
    fullState = fullState || state;

    for (var i = 0; i < reducerKeys.length; i++) {
      var key = reducerKeys[i];
      nextState[key] = reducers[key](state[key], action, fullState);
      hasChanged = hasChanged || nextState[key] !== state[key];
    }

    return hasChanged ? nextState : state;
  };
}